export default {
  data() {
    return {
      isDragging: false, // 是否正在拖拽
      offsetX: 0, // 鼠标按下的横坐标
      offsetY: 0, // 鼠标按下的纵坐标
      elementStyle: {
        position: 'fixed',
        left: '92%',
        top: '80%',
      },
      isLongPress: false,// 超过100毫秒 表示移动，不进行点击事件
    }
  },
  methods:{
    startDrag(event) {
      this.timer = setTimeout(() => {
        this.isLongPress = true;
      }, 150); // 例如，100毫秒后视为长按
      this.isDragging = true;
      this.offsetX = event.clientX - this.elementStyle.left.slice(0, -1) * window.innerWidth / 100;
      this.offsetY = event.clientY - this.elementStyle.top.slice(0, -1) * window.innerHeight / 100;
      window.addEventListener('mousemove', this.doDrag);
      window.addEventListener('mouseup', this.stopDrag);
      event.preventDefault(); 
    },
    doDrag(event) {
      if (this.isDragging) {
        const left = (event.clientX - this.offsetX) / window.innerWidth * 100 + '%';
        const top = (event.clientY - this.offsetY) / window.innerHeight * 100 + '%';
        this.elementStyle.left = left;
        this.elementStyle.top = top;
      }
    },
    stopDrag() {
      this.isDragging = false;
      window.removeEventListener('mousemove', this.doDrag);
      window.removeEventListener('mouseup', this.stopDrag);
      this.timer = setTimeout(() => {
        this.isLongPress=false;
        clearTimeout(this.timer)
      }, 100);
    }
  }
}